import { DEMO_SIGNUP, EMAIL_LOGIN, EMAIL_PASSWORD_LOGIN, EMAIL_SIGNUP, FORGOT_PASSWORD, GOOGLE_AUTH, GOOGLE_LOGIN, RESET_PASSWORD, VERIFY_LOGIN } from "./types";


export const googleLoginAction = (data, onSuccess, onError) => {
    return {
        type: GOOGLE_LOGIN,
        data,
        onSuccess,
        onError,
    };
};

export const googleAuthAction = (data, onSuccess, onError) => {
    return {
        type: GOOGLE_AUTH,
        data,
        onSuccess,
        onError,
    };
};


export const emailLoginAction = (data, onSuccess, onError) => {
    return {
        type: EMAIL_LOGIN,
        data,
        onSuccess,
        onError,
    };
};

export const emailPasswordLoginAction = (data, onSuccess, onError) => {
    return {
        type: EMAIL_PASSWORD_LOGIN,
        data,
        onSuccess,
        onError,
    };
};

export const emailSignUpAction = (data, onSuccess, onError) => {
    return {
        type: EMAIL_SIGNUP,
        data,
        onSuccess,
        onError,
    };
};


export const forgotPasswordAction = (data, onSuccess, onError) => {
    return {
        type: FORGOT_PASSWORD,
        data,
        onSuccess,
        onError,
    };
};

export const resetPasswordAction = (data, onSuccess, onError) => {
    return {
        type: RESET_PASSWORD,
        data,
        onSuccess,
        onError,
    };
};

export const verifyAndLoginAction = (data, onSuccess, onError) => {
    return {
        type: VERIFY_LOGIN,
        data,
        onSuccess,
        onError,
    };
};